import { deepCompare } from '../../utilities/comparison'

export default {
  data() {
    return {
      errorAttributes: {},
      changedAttributes: {},
    }
  },

  computed: {
    changed() {
      return this.changedAttributes ? Object.keys(this.changedAttributes) : []
    },

    isDirty() {
      return this.changed.length > 0
    },
  },

  watch: {
    attributes: {
      handler(newAttrs) {
        let changes = {}
        Object.entries(this.original).forEach(([attr, value]) => {
          if (!deepCompare(newAttrs[attr], value)) changes[attr] = newAttrs[attr]
        })
        this.changedAttributes = changes
      },
      deep: true,
    }
  },

  methods: {
    errorState(field) {
      const error = this.errorAttributes[field]
      if (error === null || error === undefined) return null
      return error.length === 0
    },

    errorsFor(field) {
      if (this.errorAttributes) return this.errorAttributes[field]
    }
  },
}